import { createAction, createPayloadAction } from '../../../core/helpers'

import {
  ADD_DISH_TYPE,
  EXPAND_DISH_TYPE_MAIN_TREE_KEYS,
  EXPAND_DISH_TYPE_SUPPORTING_TREE_KEYS,
  FETCH_DISH_TYPES,
  MOVE_DISH_TYPES,
  RENAME_DISH_TYPE,
  RESET_DISH_TYPE_TREE,
  SET_DATA_FOR_RENAMING_DISH_TYPE,
} from '../action-types'

export const cleanupFetchDishTypes = createAction(FETCH_DISH_TYPES.CLEANUP)
export const addDishTypeNode = createPayloadAction(ADD_DISH_TYPE)
export const renameDishTypeNode = createPayloadAction(RENAME_DISH_TYPE)
export const resetDishTypeTree = createAction(RESET_DISH_TYPE_TREE)
export const moveDishTypes = createPayloadAction(MOVE_DISH_TYPES)

export const setDataForRenamingDishType = createPayloadAction(
  SET_DATA_FOR_RENAMING_DISH_TYPE,
)

export const expandDishTypeMainTreeKeys = createPayloadAction(
  EXPAND_DISH_TYPE_MAIN_TREE_KEYS,
)

export const expandDishTypeSupportingTreeKeys = createPayloadAction(
  EXPAND_DISH_TYPE_SUPPORTING_TREE_KEYS,
)
